import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/announcement/listAll',
    method: 'get',
    params: params
  })
}

export function createAnnouncement(data) {
  return request({
    url: '/announcement/create',
    method: 'post',
    data: data
  })
}

export function updateAnnouncement(id, data) {
  return request({
    url: '/announcement/update/' + id,
    method: 'post',
    data: data
  })
}

export function deleteAnnouncement(id) {
  return request({
    url: '/announcement/delete/' + id,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/announcement.js